/* ==========================================================
   CONFIGURATOR STATE & INITIALIZATION
   ========================================================== */
const shadeCatalog = window.shadeCatalog || [];

let targetQuantity = 5;
let activeSlotIndex = null;
let selectedProducts = [];
let currentActiveTag = 'all';
let currentSearchQuery = '';

function initBundleConfigurator() {
  // 1. Find active tier card
  const activeCard = document.querySelector('.pb-bundle-card.is-selected') || document.querySelector('.pb-bundle-card');
  
  if (activeCard) {
    // Read quantity, price, and compare price from the active card
    targetQuantity = parseInt(activeCard.getAttribute('data-quantity'), 10) || 5;
    const initialPrice = activeCard.getAttribute('data-price') || '';
    const initialComparePrice = activeCard.getAttribute('data-compare-price') || '';

    // Synchronize initial pricing UI with active card (e.g. 999 kr for Favorite Package)
    updatePricingUI(initialPrice, initialComparePrice);
  }
  
  // 2. Initialize selected items array to match target quantity
  if (selectedProducts.length !== targetQuantity) {
    selectedProducts = new Array(targetQuantity).fill(null);
  }

  // 3. Render initial UI slots and progress
  renderSlots();
  updateProgressUI();
  updateDrawerSelectedBar();
}

/* ==========================================================
   TIER CARD SELECTION & PRICING
   ========================================================== */
function selectBundleTier(element) {
  // 1. Clear selection from all cards
  document.querySelectorAll('.pb-bundle-card').forEach(card => {
    card.classList.remove('is-selected');
    card.removeAttribute('data-selected');
  });

  // 2. Set active card state
  element.classList.add('is-selected');
  element.setAttribute('data-selected', 'true');

  // 3. Read tier quantity & price attributes
  targetQuantity = parseInt(element.getAttribute('data-quantity'), 10) || 5;
  const price = element.getAttribute('data-price') || '';
  const comparePrice = element.getAttribute('data-compare-price') || '';

  // 4. Update Header & Cart Pricing UI
  updatePricingUI(price, comparePrice);

  // 5. Adjust selectedProducts array length to match new tier limit
  if (selectedProducts.length > targetQuantity) {
    selectedProducts = selectedProducts.slice(0, targetQuantity);
  } else if (selectedProducts.length < targetQuantity) {
    while (selectedProducts.length < targetQuantity) {
      selectedProducts.push(null);
    }
  }

  // 6. Refresh slots and progress indicators
  renderSlots();
  updateProgressUI();
  updateDrawerSelectedBar();
  renderDrawerProducts();
}

function updatePricingUI(price, comparePrice) {
  const dynamicPrice = document.getElementById('pb-dynamic-price');
  const dynamicComparePrice = document.getElementById('pb-dynamic-compare-price');
  const savingsBadge = document.getElementById('pb-dynamic-savings-badge');
  
  const btnTotalPrice = document.getElementById('pb-btn-total-price');
  const btnComparePrice = document.getElementById('pb-btn-compare-price');

  if (price) {
    if (dynamicPrice) dynamicPrice.textContent = price;
    if (btnTotalPrice) btnTotalPrice.textContent = price;
  }

  const parseAmount = (str) => {
    if (!str) return 0;
    const cleanStr = str.replace(/[^\d.,]/g, '');
    if (cleanStr.includes(',') && cleanStr.includes('.')) {
      return parseFloat(cleanStr.replace('.', '').replace(',', '.'));
    }
    return parseFloat(cleanStr.replace(',', '.'));
  };

  const numPrice = parseAmount(price);
  const numCompare = parseAmount(comparePrice);

  if (comparePrice && comparePrice.trim() !== '' && numCompare > numPrice) {
    if (dynamicComparePrice) {
      dynamicComparePrice.textContent = comparePrice;
      dynamicComparePrice.style.display = 'inline-block';
    }

    if (btnComparePrice) {
      btnComparePrice.textContent = comparePrice;
      btnComparePrice.style.display = 'inline-block';
    }

    if (savingsBadge) {
      const discountPercent = Math.round(((numCompare - numPrice) / numCompare) * 100);
      savingsBadge.textContent = `-${discountPercent}%`;
      savingsBadge.style.display = 'inline-block';
    }
  } else {
    if (dynamicComparePrice) dynamicComparePrice.style.display = 'none';
    if (btnComparePrice) btnComparePrice.style.display = 'none';
    if (savingsBadge) savingsBadge.style.display = 'none';
  }
}

/* ==========================================================
   SLOTS RENDERER & PROGRESS UI
   ========================================================== */
function renderSlots() {
  const container = document.getElementById('pb-slots-container');
  if (!container) return;
  container.innerHTML = '';

  for (let i = 1; i <= targetQuantity; i++) {
    const slot = document.createElement('div');
    const selectedItem = selectedProducts[i - 1];

    if (selectedItem) {
      slot.className = 'pb-slot is-filled';
      slot.innerHTML = `
        <img src="${selectedItem.image}" alt="${selectedItem.title}" style="width: 54px; height: 54px; border-radius: 8px; object-fit: cover; margin-bottom: 6px;">
        <span class="pb-slot__text" style="color: var(--pb-primary); font-weight: 500;">${selectedItem.title}</span>
        <button type="button" style="font-size: 11px; text-decoration: underline; margin-top: 4px; color: var(--pb-secondary); cursor: pointer; border: none; background: none;" onclick="event.stopPropagation(); removeShade(${i - 1})">Endre</button>
      `;
    } else {
      slot.className = 'pb-slot';
      slot.style.cursor = 'pointer';
      slot.setAttribute('onclick', `openShadeDrawer(${i - 1})`);
      slot.innerHTML = `
        <div class="pb-slot__plus"></div>
        <span class="pb-slot__text">Velg Farge ${i}</span>
      `;
    }

    container.appendChild(slot);
  }

  // Keep drawer preview bar updated
  updateDrawerSelectedBar();
}

function updateProgressUI() {
  const selectedCount = selectedProducts.filter(Boolean).length;
  const remaining = Math.max(0, targetQuantity - selectedCount);
  const percentage = Math.min(100, (selectedCount / targetQuantity) * 100);

  const progressBar = document.getElementById('pb-progress-bar');
  if (progressBar) {
    progressBar.style.width = percentage + '%';
  }

  const progressText = document.getElementById('pb-progress-text');
  if (progressText) {
    progressText.textContent = `${selectedCount} av ${targetQuantity} valgt`;
  }

  const btn = document.getElementById('pb-add-to-cart-btn');
  const btnText = document.getElementById('pb-btn-text');

  if (btn && btnText) {
    if (remaining > 0) {
      btn.disabled = true;
      btnText.textContent = `VELG ${remaining} FARG${remaining > 1 ? 'ER' : ''} TIL`;
    } else {
      btn.disabled = false;
      btnText.textContent = 'LEGG I HANDLEKURV';
    }
  }
}

/* ==========================================================
   DRAWER PRODUCTS & FILTERING
   ========================================================== */
function renderDrawerProducts() {
  const container = document.getElementById('pb-drawer-products');
  if (!container) return;
  container.innerHTML = '';

  const selectedCounts = selectedProducts.reduce((acc, item) => {
    if (item && item.id) {
      acc[item.id] = (acc[item.id] || 0) + 1;
    }
    return acc;
  }, {});

  const filteredProducts = shadeCatalog.filter(item => {
    const matchesTag = currentActiveTag === 'all' || (item.tags && item.tags.includes(currentActiveTag));
    const matchesSearch = item.title.toLowerCase().includes(currentSearchQuery.toLowerCase());
    return matchesTag && matchesSearch;
  });

  if (filteredProducts.length === 0) {
    container.innerHTML = '<div style="grid-column: 1 / -1; text-align: center; padding: 40px 0; color: #666;">Ingen farger funnet.</div>';
    return;
  }

  filteredProducts.forEach(item => {
    const count = selectedCounts[item.id] || 0;
    const isAvailable = item.available !== false; // Check availability from Liquid

    const card = document.createElement('div');
    card.className = `pb-product-card ${count > 0 ? 'is-selected-item' : ''} ${!isAvailable ? 'is-out-of-stock' : ''}`;
    
    // Only attach click event if the product is in stock
    if (isAvailable) {
      card.onclick = () => {
        card.classList.add('is-just-selected');
        const btn = card.querySelector('.pb-product-card__btn');
        if (btn) {
          btn.classList.add('is-added-state');
          btn.textContent = '✓ Lagt til!';
        }

        setTimeout(() => {
          card.classList.remove('is-just-selected');
          selectShadeForActiveSlot(item);
        }, 250);
      };
    }

    const tickBadgeHTML = count > 0 
      ? `<span class="pb-card-tick-badge">✓</span>` 
      : '';

    const countBadgeHTML = count > 0 
      ? `<span class="pb-card-count-badge">${count}x Valgt</span>` 
      : '';

    // Determine button label and disabled attributes
    let buttonText = 'Velg';
    if (!isAvailable) {
      buttonText = 'Utsolgt';
    } else if (count > 0) {
      buttonText = 'Legg til en til';
    }

    card.innerHTML = `
      ${tickBadgeHTML}
      ${countBadgeHTML}
      <img src="${item.image}" alt="${item.title}" loading="lazy">
      <div class="pb-product-card__title">${item.title}</div>
      <button type="button" class="pb-product-card__btn ${count > 0 ? 'is-added-state' : ''} ${!isAvailable ? 'is-disabled' : ''}" ${!isAvailable ? 'disabled' : ''}>${buttonText}</button>
    `;
    container.appendChild(card);
  });
}

function filterByTag(tag, button) {
  currentActiveTag = tag;
  document.querySelectorAll('.pb-filter-tag').forEach(b => b.classList.remove('is-active'));
  if (button) button.classList.add('is-active');
  renderDrawerProducts();
}

function handleSearchFilter(query) {
  currentSearchQuery = query;
  renderDrawerProducts();
}

function openShadeDrawer(slotIndex) {
  activeSlotIndex = slotIndex;
  renderDrawerProducts();
  
  const drawer = document.getElementById('pb-shade-drawer') || document.querySelector('.pb-drawer');
  if (drawer) drawer.classList.add('active');
  document.body.classList.add('pb-no-scroll');
}

function closeShadeDrawer() {
  const drawer = document.getElementById('pb-shade-drawer') || document.querySelector('.pb-drawer');
  if (drawer) drawer.classList.remove('active');
  document.body.classList.remove('pb-no-scroll');
}

function selectShadeForActiveSlot(productData) {
  if (activeSlotIndex !== null) {
    selectedProducts[activeSlotIndex] = productData;
    renderSlots();
    updateProgressUI();
    renderDrawerProducts();

    let nextEmptyIndex = -1;
    for (let i = 0; i < targetQuantity; i++) {
      if (!selectedProducts[i]) {
        nextEmptyIndex = i;
        break;
      }
    }

    if (nextEmptyIndex !== -1) {
      activeSlotIndex = nextEmptyIndex;
    } else {
      activeSlotIndex = null;
      closeShadeDrawer();
    }
  }
}

function removeShade(index) {
  selectedProducts[index] = null;
  renderSlots();
  updateProgressUI();
  renderDrawerProducts();
}

/* ==========================================================
   DRAWER SELECTED SUMMARY BAR & CLEAR FUNCTIONS
   ========================================================== */
function updateDrawerSelectedBar() {
  const countEl = document.getElementById('pb-drawer-selected-count');
  const listEl = document.getElementById('pb-drawer-selected-list');
  const clearBtn = document.getElementById('pb-drawer-clear-btn');

  if (!listEl) return;

  const filledItems = selectedProducts.filter(Boolean);

  if (countEl) {
    countEl.textContent = `Fremgang: ${filledItems.length} av ${targetQuantity} valgt`;
  }

  if (clearBtn) {
    clearBtn.style.display = filledItems.length > 0 ? 'inline-block' : 'none';
  }

  listEl.innerHTML = '';

  for (let i = 0; i < targetQuantity; i++) {
    const item = selectedProducts[i];

    if (item) {
      const thumb = document.createElement('div');
      thumb.className = 'pb-drawer-thumb';
      thumb.innerHTML = `
        <img src="${item.image}" alt="${item.title}" />
        <button type="button" class="pb-drawer-thumb__remove" onclick="removeProductFromSlot(${i})" aria-label="Fjern">×</button>
      `;
      listEl.appendChild(thumb);
    } else {
      const emptyThumb = document.createElement('div');
      emptyThumb.className = 'pb-drawer-thumb--empty';
      emptyThumb.innerHTML = '+';
      listEl.appendChild(emptyThumb);
    }
  }
}

function clearSelectedProducts() {
  // 1. Reset selection array to empty values matching target quantity
  selectedProducts = new Array(targetQuantity).fill(null);

  // 2. Refresh UI elements
  renderSlots();
  updateProgressUI();
  updateDrawerSelectedBar();
  renderDrawerProducts();
}

function removeProductFromSlot(index) {
  if (index >= 0 && index < selectedProducts.length) {
    selectedProducts[index] = null;
    
    // Move remaining items forward so empty slots remain at the end
    selectedProducts = selectedProducts.filter(Boolean);
    while (selectedProducts.length < targetQuantity) {
      selectedProducts.push(null);
    }

    renderSlots();
    updateProgressUI();
    updateDrawerSelectedBar();
    renderDrawerProducts();
  }
}

function changeDrawerGridColumns(columns, buttonEl) {
  const gridContainer = document.getElementById('pb-drawer-products');
  if (!gridContainer) return;

  gridContainer.classList.remove('cols-2', 'cols-3', 'cols-4');
  gridContainer.classList.add(`cols-${columns}`);

  document.querySelectorAll('.pb-grid-btn').forEach(btn => {
    btn.classList.remove('is-active');
  });
  if (buttonEl) {
    buttonEl.classList.add('is-active');
  }
}

/* ==========================================================
   ACCORDION & GALLERY MEDIA FUNCTIONS
   ========================================================== */
function toggleIncAccordion(buttonEl) {
  const accordion = buttonEl.closest('.pb-inc-accordion');
  const accordionGroup = buttonEl.closest('.pb-inc-accordion-list');

  if (!accordion) return;

  const isOpen = accordion.classList.contains('is-open');

  // Close other accordions if placed inside a single-active group
  if (accordionGroup) {
    accordionGroup.querySelectorAll('.pb-inc-accordion').forEach(acc => {
      acc.classList.remove('is-open');
      const btn = acc.querySelector('.pb-inc-accordion__toggle');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  }

  if (!isOpen) {
    accordion.classList.add('is-open');
    buttonEl.setAttribute('aria-expanded', 'true');
  }
}

function switchGalleryMedia(mediaId, button) {
  const container = document.getElementById('pb-viewer-container');
  const template = document.getElementById('pb-media-template-' + mediaId);

  const targetMedia = template 
    ? template.content || template 
    : document.querySelector(`[data-media-id="${mediaId}"]`);

  if (container && targetMedia) {
    container.querySelectorAll('video').forEach(video => video.pause());

    if (template) {
      container.innerHTML = template.innerHTML;
    } else {
      container.innerHTML = targetMedia.innerHTML;
    }

    const newVideo = container.querySelector('video');
    if (newVideo) {
      newVideo.play().catch(err => console.log("Autoplay prevented:", err));
    }

    const newIframe = container.querySelector('iframe');
    if (newIframe && newIframe.src && !newIframe.src.includes('autoplay=1')) {
      newIframe.src += (newIframe.src.includes('?') ? '&' : '?') + 'autoplay=1';
    }

    document.querySelectorAll('.pb-gallery__thumb').forEach(thumb => {
      thumb.classList.remove('is-active');
    });

    if (button) button.classList.add('is-active');
  }
}

/* ==========================================================
   ADD BUNDLE TO CART
   ========================================================== */
async function handleBundleAddToCart() {
  const addButton = document.getElementById('pb-add-to-cart-btn');
  const btnText = document.getElementById('pb-btn-text');
  const activeCard = document.querySelector('.pb-bundle-card.is-selected') || document.querySelector('.pb-bundle-card');

  const selectedItems = selectedProducts.filter(Boolean);

  if (selectedItems.length !== targetQuantity) {
    alert('Fullfør fargevalget ditt først.');
    return;
  }

  const parentVariantId = activeCard ? String(activeCard.getAttribute('data-variant-id') || '').trim() : '';

  if (!parentVariantId || !/^\d+$/.test(parentVariantId)) {
    alert(`Bundle variant ID is not mapped for ${targetQuantity} colors in Theme Editor.`);
    return;
  }

  if (addButton) addButton.disabled = true;
  if (btnText) btnText.textContent = 'Legger til...';

  const rootUrl = window.Shopify?.routes?.root || '/';

  try {
    const bundleId = Date.now().toString();

    const grouped = {};
    selectedItems.forEach(item => {
      const variantId = String(item.id);
      grouped[variantId] = (grouped[variantId] || 0) + 1;
    });

    const items = [];

    Object.keys(grouped).forEach(variantId => {
      items.push({
        id: Number(variantId),
        quantity: grouped[variantId],
        properties: {
          _bundle: 'true',
          _bundle_id: bundleId,
          _bundle_size: targetQuantity
        }
      });
    });

    items.push({
      id: Number(parentVariantId),
      quantity: 1,
      properties: {
        _bundle_parent: 'true',
        _bundle_id: bundleId,
        _bundle_size: targetQuantity
      }
    });

    const response = await fetch(`${rootUrl}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items })
    });

    const data = await response.json();

    if (!response.ok || data.status) {
      throw new Error(data.description || 'Kunne ikke legge til i handlekurven');
    }

    if (btnText) btnText.textContent = 'Lagt til ✓';

    setTimeout(async () => {
      closeShadeDrawer();

      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));

      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.open === 'function') {
        cartDrawer.open();
      } else if (window.CartDrawer?.renderContents) {
        const cart = await fetch(`${rootUrl}cart.js`).then(r => r.json());
        window.CartDrawer.renderContents(cart);
      } else if (window.upcartOpenCart) {
        window.upcartOpenCart();
      } else {
        window.location.href = `${rootUrl}cart`;
      }
    }, 300);

  } catch (error) {
    console.error('Bundle cart error:', error);
    if (btnText) btnText.textContent = 'Prøv Igjen';
    alert(error.message || 'Kunne ikke legge til pakken.');
  } finally {
    if (addButton) addButton.disabled = false;
  }
}

// Initializers
initBundleConfigurator();

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initBundleConfigurator);
}
window.addEventListener('load', initBundleConfigurator);
document.addEventListener('shopify:section:load', initBundleConfigurator);